import React, { useState } from 'react';
import { useIntl } from 'gatsby-plugin-intl';
import { Link } from 'gatsby';
import { FooterBG } from './styles';

export const Footer = () => {
  const { formatMessage, locale } = useIntl();
  const [email, setEmail] = useState('');

  const handleSubmit = () => {
    console.log(email);
  };

  return (
    <FooterBG className="py-8 md:pt-12 lg:pt-16">
      <div className="xl:container mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row">
        <div className="flex flex-col sm:flex-row flex-1">
          <div className="mb-12 flex-1">
            <h2 className="font-heading text-xl font-bold mb-4 md:mb-10">
              {formatMessage({ id: 'footer.menu1.title' })}
            </h2>
            <ul>
              <li className="mb-3">
                <Link to="/">{formatMessage({ id: 'footer.menu1.aboutUs' })}</Link>
              </li>
              <li className="mb-3">
                <Link to={`/${locale}/imprint/`}>{formatMessage({ id: 'footer.menu2.imprint' })}</Link>
              </li>
              {/* <li className="mb-3">
                <Link to="/">{formatMessage({ id: 'footer.menu1.blog' })}</Link>
              </li> */}
              <li className="mb-3">
                <Link to="/">{formatMessage({ id: 'footer.menu1.career' })}</Link>
              </li>
              <li className="mb-3">
                <Link to="/">{formatMessage({ id: 'footer.menu1.influencer' })}</Link>
              </li>
            </ul>
          </div>
          <div className="mb-12 flex-1">
            <h2 className="font-heading text-xl font-bold mb-4 md:mb-10">
              {formatMessage({ id: 'footer.menu2.title' })}
            </h2>
            <ul>
              <li className="mb-3">
                <Link to={`/${locale}/contact/`}>{formatMessage({ id: 'footer.menu2.contact' })}</Link>
              </li>
              <li className="mb-3">
                <Link to={`/${locale}/tos/`}>{formatMessage({ id: 'footer.menu2.tos' })}</Link>
              </li>
              <li className="mb-3">
                <Link to={`/${locale}/privacy-policy/`}>{formatMessage({ id: 'footer.menu2.data' })}</Link>
              </li>
              <li className="mb-3">
                <Link to={`/${locale}/delivery/`}>{formatMessage({ id: 'footer.menu2.delivery' })}</Link>
              </li>
              <li className="mb-3">
                <Link to={`/${locale}/payment-and-delivery/`}>{formatMessage({ id: 'footer.menu2.payment' })}</Link>
              </li>
              <li className="mb-3">
                <Link to={`/${locale}/cancellation/`}>{formatMessage({ id: 'footer.menu2.cancellation' })}</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col mb-16 lg:w-2/5">
          <h2 className="font-heading text-xl font-bold mb-4 md:mb-10">
            {formatMessage({ id: 'footer.newsletter.title' })}
          </h2>
          <p className="mb-4">{formatMessage({ id: 'footer.newsletter.description' })}</p>
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row">
              <input
                onChange={(event) => setEmail(event.target.value)}
                type="email"
                placeholder={formatMessage({ id: 'footer.newsletter.placeholder' })}
                className=" flex-1 border-2 border-blue-900 px-4 py-3 bg-white w-full mb-4 md:mb-0 md:mr-2"
              />
              <button
                disabled={!email}
                type="submit"
                className="block bg-blue-900 px-4 py-2 text-white font-medium cursor-pointer hover:bg-blue-800 disabled:bg-gray-600 disabled:cursor-not-allowed">
                {formatMessage({ id: 'footer.newsletter.button' })}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="text-center">© 2020 bluli</div>
    </FooterBG>
  );
};
